import { defaultColumns, defaultSort } from '../../components/users/columns';

export default {
  state: {
    users: [],
    representatives: [],
    paginatedUsers: [],
    tableConfig: null,
    loading: false,
    currentPage: 1,
    filterString: null,
    sorting: {
      prop: 'created_at',
      order: 'asc',
    },
  },
  getters: {
    users: state => state.users,
    representatives: state => state.representatives,
    paginatedUsers: state => state.paginatedUsers,
    tableConfig: state => state.tableConfig,
    loading: state => state.loading,
    sorting: state => state.sorting,
    filterString: state => state.filterString,
    currentPage: state => state.currentPage,
  },
  mutations: {
    setUsers(state, users) {
      state.users = users;
    },
    setRepresentatives(state, users) {
      state.representatives = users;
    },
    setTableConfig(state, config) {
      state.tableConfig = config;
    },
    setSorting(state, sorting) {
      state.sorting = sorting;
    },
    setFilterString(state, filter) {
      state.filterString = filter;
    },
    setCurrentPage(state, currentPage) {
      state.currentPage = currentPage;
    },
    setPaginatedUsers(state, paginatedUsers) {
      state.paginatedUsers = paginatedUsers
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchTableConfig({ commit }) {
      try {
        const setting = await axios.get('api/table-settings/user-list');
        const tableConfig = {
          id: setting.id || null,
          type: 'user-list',
          columns: setting.id ? JSON.parse(setting.config).columns : defaultColumns,
          sort: setting.id ? JSON.parse(setting.config).sort : defaultSort,
        };
        commit('setTableConfig', tableConfig);
      } catch (e) {
      }
    },
    async fetchAll({ commit, state, dispatch }) {
      commit('setLoading', true);
      try {
        const users = await axios.get('api/users');
        commit('setUsers', users);
      } catch (e) {
      }
      commit('setLoading', false);
    },

    async fetchRepresentatives({ commit, state, dispatch }) {
      commit('setLoading', true);
      try {
        const users = await axios.get('api/users?is_representative=1');
        commit('setRepresentatives', users);
      } catch (e) {
      }
      commit('setLoading', false);
    },
    async fetchAllWithPagination({ commit, state, dispatch }, queryString) {
      commit('setLoading', true);
      try {
        if (!state.tableConfig) {
          await dispatch('fetchTableConfig');
        }
        if (queryString) {
          commit('setFilterString', queryString.substr(1));
        } else if (queryString === '') {
          commit('setCurrentPage', 1);
          commit('setFilterString', '');
        } else {
          commit('setFilterString', state.filterString || '');
        }
        const query = `?page=${state.currentPage}&sortby=${state.sorting.prop}&sorttype=${state.sorting.order === 'ascending' ? 'asc' : 'desc'}&${state.filterString}`;
        const users = await axios.get('api/users/paginated' + (query || ''));
        commit('setPaginatedUsers', users);
      } catch (e) {
      }
      commit('setLoading', false);
      return await axios.get('api/users');
    },
    async fetch({ commit }, id) {
      return await axios.post(`api/users/${id}`);
    },
    async create({ commit }, user) {
      await axios.post('api/users', user);
    },
    async update({ commit }, user) {
      await axios.put('api/users', user);
    },
    async delete({ commit }, id) {
      await axios.delete(`api/users/${id}`);
    },
  },
};
